import axios from 'axios';

// Cliente de API do CONTROLE DE COMBUSTÍVEL (frota). Domínio próprio /api/fuel/*
// (Plan 01 do F3: alias 1:1 dos callables server-authoritative que hoje vivem sob o
// prefixo "lab" de combustível — comportamento idêntico por construção, zero duplicação
// de lógica). O kiosk /api/lab/* permanece intocado (D-14) — este client NUNCA aponta pra lá.
// O token JWT é anexado globalmente via axios.defaults pelo AuthContext.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fuelApi = {
  // Saldo server-authoritative + analytics (autonomia/reserva/taxa/by_motor).
  getFuelSaldo: (equipmentId) =>
    axios.get(`${API}/fuel/saldo`, { params: { equipment_id: equipmentId } }),

  // Eventos de combustível (refuel/override/...).
  getFuelRecords: (equipmentId, params = {}) =>
    axios.get(`${API}/fuel/records`, { params: { equipment_id: equipmentId, ...params } }),

  // Relatório de defasagem (oficial × sensor × NF), server-authoritative.
  getFuelDefasagem: (equipmentId, params = {}) =>
    axios.get(`${API}/fuel/defasagem`, { params: { equipment_id: equipmentId, ...params } }),

  // Fase 2 (escrita) — lançamento de abastecimento.
  createFuelRecord: (data) =>
    axios.post(`${API}/fuel/records`, data),

  // Config de tanque por equipamento (capacidade, reserva, sensor paths, detector).
  getFuelConfig: (equipmentId) =>
    axios.get(`${API}/fuel/config/${equipmentId}`),

  putFuelConfig: (equipmentId, data) =>
    axios.put(`${API}/fuel/config/${equipmentId}`, data),

  // Relação dos sensores (fields do Influx, 30d) do equipamento — alimenta a
  // seleção com busca dos paths de sensor na aba Tanques.
  getSensorPaths: (equipmentId) =>
    axios.get(`${API}/fuel/sensor-paths`, { params: { equipment_id: equipmentId } }),

  // Detecções pendentes do detector de abastecimento (Plan 07 as consome).
  getDetections: (equipmentId, params = {}) =>
    axios.get(`${API}/fuel/detections`, { params: { equipment_id: equipmentId, ...params } }),

  dismissDetection: (data) =>
    axios.post(`${API}/fuel/detections/dismiss`, data),

  // Histórico do tanque (timeline saldo/sensor/eventos, Plan 05).
  getTimeline: (equipmentId, params = {}) =>
    axios.get(`${API}/fuel/timeline`, { params: { equipment_id: equipmentId, ...params } }),
};

export default fuelApi;
